<template>
  <a-drawer
    :title="$t('title.coldChainEdit')"
    placement="right"
    :closable="false"
    :visible="visible"
    width="25%"
    @close="onClose">
    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="order">
        <a-form-model-item :label="$t('business.label.conveyance')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="conveyance">
          <vxe-select v-model="order.conveyance.id" :options="conveyances" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.tempControlMode')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="tempControlMode">
          <vxe-select v-model="order.tempControlMode.id" :options="tempControlModes" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.departureTime')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="departureTime">
          <a-date-picker v-model="order.departureTime" style="width: 100%;" valueFormat="YYYY-MM-DD"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.arrivalTime')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="arrivalTime">
          <a-date-picker v-model="order.arrivalTime" style="width: 100%;" valueFormat="YYYY-MM-DD"/>
        </a-form-model-item>

        <a-form-model-item :label="$t('business.label.departureTemp')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="departureTemp">
          <vxe-number-input v-model="order.temperature.departureTemp" style="width: 100%;"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.arrivalTemp')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="arrivalTemp">
          <vxe-number-input v-model="order.temperature.arrivalTemp" style="width: 100%;"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.maximumTemp')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="maximumTemp">
          <vxe-number-input v-model="order.temperature.maximumTemp" style="width: 100%;"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.minimumTemp')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="minimumTemp">
          <vxe-number-input v-model="order.temperature.minimumTemp" style="width: 100%;"/>
        </a-form-model-item>

        <a-form-model-item>
          <a-button style="float: right" type="primary" @click="onClose">{{$t('button.close')}}</a-button>
          <a-button style="float: right;margin-right: 10px" type="primary" @click="confirm">{{$t('button.confirm')}}</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-drawer>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { WAREHOUSE } from '@/store/mutation-types'
import { findAll, findOne, post } from '@/api/Api'
import { BaseObject } from '@/api/dto/BaseObject'
import { AsnOrder } from '@/api/dto/order/AsnOrder'

export default {
  name: 'ColdChainEditDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      conveyances: [],
      tempControlModes: [],
      order: new AsnOrder(),
      warehouse: Vue.ls.get(WAREHOUSE)
    }
  },
  created() {
    findOne('fieldFactory', { no: 'CONVEYANCE' }).then(res => {
      if (res.success) {
        this.conveyances = res.result.dictionaries
      }
    })
    findOne('fieldFactory', { no: 'TEMP_CONTROL_MODE' }).then(res => {
      if (res.success) {
        this.tempControlModes = res.result.dictionaries
      }
    })
  },
  methods: {
    open(no) {
      this.visible = true
      if (no === undefined || no === null) {
        let that = this
        return this.$confirm({
          title: '无单据编号,无法编辑冷链信息',
          content: '将关闭冷链编辑窗口',
          onOk() {
            that.visible = false
          },
          onCancel() {
            that.visible = false
          },
          centered: true
        })
      }
      this.loading = true
      findAll('asnOrderFactory', { no: no }).then(res => {
        if (res.success && res.result.length > 0) {
          const result = res.result[0]
          this.order = new AsnOrder(BaseObject.merge(result, 'order'))
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.loading = true
      this.$refs.form.validate((success) => {
        if (success) {
          this.order.warehouse = this.warehouse
          post(api.receivingAsnSave, { type: 'normalAsn' }, this.order.toJSONObject()).then(res => {
            if (res.success) {
              this.$emit('success', res.result)
              this.onClose()
            }
          }).finally(() => this.loading = false)
        }
      })
    },
    onClose() {
      this.visible = false
      this.clear()
    },
    clear() {
      this.order = new AsnOrder()
    }
  }
}
</script>